export default __webpack_public_path__ + "static/media/computer-geek.e5ee88ca.svg";